var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 24,
    fill: "#121212"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 48,
    r: 24,
    fill: "#121212"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 48,
    r: 24,
    fill: "#121212"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 48,
    r: 24,
    fill: "#121212"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 48,
    r: 24,
    fill: "#121212"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 174,
    r: 24,
    fill: "#121212"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 174,
    r: 24,
    fill: "#121212"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 174,
    r: 24,
    fill: "#121212"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 174,
    r: 24,
    fill: "#121212"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 174,
    r: 24,
    fill: "#121212"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 300,
    r: 24,
    fill: "#121212"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 300,
    r: 24,
    fill: "#121212"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 24,
    fill: "#121212"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 300,
    r: 24,
    fill: "#121212"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 300,
    r: 24,
    fill: "#121212"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 426,
    r: 24,
    fill: "#121212"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 426,
    r: 24,
    fill: "#121212"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 426,
    r: 24,
    fill: "#121212"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 426,
    r: 24,
    fill: "#121212"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 426,
    r: 24,
    fill: "#121212"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 552,
    r: 24,
    fill: "#121212"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 552,
    r: 24,
    fill: "#121212"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 552,
    r: 24,
    fill: "#121212"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 552,
    r: 24,
    fill: "#121212"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 552,
    r: 24,
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallPattern);
export default __webpack_public_path__ + "static/media/ball-pattern.1bbfa99f0648d3ea23e6d50fdf27356b.svg";
export { ForwardRef as ReactComponent };